export default function ProjectCard({ project }) {
  return (
    <div className="group overflow-hidden rounded-lg bg-white shadow-sm ring-1 ring-black/5 transition-shadow hover:shadow-lg">
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={project.image}
          alt={project.imageAlt}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-5">
        <span className="font-display text-xs uppercase tracking-wide text-brick">
          {project.sector}
        </span>
        <h3 className="mt-1 font-display text-lg font-semibold text-charcoal">
          {project.name}
        </h3>
        <p className="mt-2 text-sm text-steel">{project.description}</p>
      </div>
    </div>
  );
}
